var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import GenericCollapsibleNavigation, { ESidebarTrigger, } from "../../../shared-library/components/GenericCollapsibleNavigation";
import logoIcon from "../../../shared-library/assets/images/generic/nuvama_one_logo1.svg";
import nameLogo from "../../../shared-library/assets/images/generic/nuvama_one_logo.svg";
import learnicon from "@frameworks/shared-library/assets/images/SalesJourney/Header/LearnIcon.svg";
import "../../stylesheets/components/Sidebar/NaviagtionSidebar.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import loginDi from "@frameworks/salesjourney/components/Login/di/index";
import GenericPopup from "../../../shared-library/components/GenericPopup";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import config from "@frameworks/salesjourney/config/domain";
import GenericTooltip from "../../../shared-library/components/GenericTooltip";
import { accountDetails } from "@salesdi";
import profileDi from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { jwtDecode } from "jwt-decode";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import { checkIfMFIsAccessible, checkIfARNIsAccessible, } from "@frameworks/salesjourney/utils/genericMethods";
import AccountOpening from "@frameworks/salesjourney/components/Lead/AccountOpening/AccountOpening";
import cloneDeep from "lodash/cloneDeep";
export var EnumRouteTitles;
(function (EnumRouteTitles) {
    EnumRouteTitles["PLACE_ORDER"] = "Place Order";
    EnumRouteTitles["HOME"] = "Home";
    EnumRouteTitles["LEAD_DASHBOARD"] = "Lead Dashboard";
    EnumRouteTitles["REVENUE_DASHBOARD"] = "Revenue Dashboard";
    // WATCH_LIST = "Offerings",
    // ACTIVITY_BOOK = "Activity Book",
    EnumRouteTitles["PRODUCT_BOUQUET"] = "Product Bouquet";
    EnumRouteTitles["ORDER_BOOK"] = "Order Book";
    EnumRouteTitles["REPORTS"] = "Reports";
    EnumRouteTitles["RM_PARTNER_REPORT"] = "RM Partner Reports";
    EnumRouteTitles["SUPERSET_REPORT"] = "Superset Reports";
    EnumRouteTitles["CLIENT_REPORTS"] = "Client Reports";
    EnumRouteTitles["SERVICE_REQUEST"] = "Service Request";
    EnumRouteTitles["OPEN_ACCOUNT"] = "Open an Account";
    EnumRouteTitles["ADVISORY"] = "Advisory";
    EnumRouteTitles["TRANSFER_IN"] = "Transfer-In";
    EnumRouteTitles["MUTUAL_FUNDS"] = "Mutual Funds";
    EnumRouteTitles["OTHER_ONFO"] = "Other Apps";
    EnumRouteTitles["AOP_LEADS"] = "AOP Leads";
    EnumRouteTitles["BULLPEN"] = "Bullpen";
    EnumRouteTitles["CIP"] = "CIP";
    EnumRouteTitles["OLD_PARTNER_PORTAL"] = "Old Partner Portal";
    EnumRouteTitles["NLA"] = "NLA";
    EnumRouteTitles["NUWAI"] = "NUWAi";
    EnumRouteTitles["WATCH_LIST"] = "Watch List";
    EnumRouteTitles["TRANSACTIONS"] = "Transactions";
})(EnumRouteTitles || (EnumRouteTitles = {}));
var NavigationSidebar = function (props) {
    var bullpenDirectionUrl = "";
    var _a = __read(React.useState(false), 2), isShowOpenAccountModal = _a[0], setIsShowOpenAccountModal = _a[1];
    var _b = __read(React.useState([]), 2), accountOpeningUrls = _b[0], setAccountOpeningUrls = _b[1];
    var getBullpenRedirectionRouteUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, accountDetails.getSalesAuthToken()];
                case 1:
                    token = _a.sent();
                    bullpenDirectionUrl = config.bullpenDirectionBaseUrl + "?Token=" + token;
                    window.open(bullpenDirectionUrl, "_blank");
                    return [2 /*return*/];
            }
        });
    }); };
    var redirectToFPDPortal = function () {
        loginDi.login.redirectionToFPDUrl().then(function (resp) {
            window.open(resp === null || resp === void 0 ? void 0 : resp.url, "_blank");
        });
    };
    var getOtherAppRedirectingURL = function (e) {
        loginDi.login.getGuidToken({ strapp: e === null || e === void 0 ? void 0 : e.title }).then(function (resp) {
            window.open(resp === null || resp === void 0 ? void 0 : resp.data, "_blank");
        });
    };
    var openAccountModal = function () {
        setIsShowOpenAccountModal(!isShowOpenAccountModal);
    };
    var getNuwaiRedirectURL = function () {
        var token = jwtDecode(localStorage.getItem("access_token"));
        if (token === null || token === void 0 ? void 0 : token.email) {
            //let nuwaiRoute = `https://nuvamalearning.skilliq.co?email=${token.email}`;
            var nuwaiRoute = "https://login.microsoftonline.com/9201f936-0a1d-49af-82ee-4ee4345c1ad7/oauth2/v2.0/authorize?client_id=a57ea918-1b3b-4211-a7eb-b248d2ed4dc0&response_type=code&redirect_uri=https://nuvamalearning.skilliq.co/redirect&response_mode=query&scope=https://graph.microsoft.com/User.Read&state=12345&sso_reload=true";
            window.open(nuwaiRoute, "_blank");
        }
    };
    var sidebarNavConstants = [
        {
            title: EnumRouteTitles.PLACE_ORDER,
            value: EnumRouteTitles.PLACE_ORDER,
            route: "/dashboard/place-order",
            icon: React.createElement("i", { className: "edel-icon-add-square" }),
            routeState: { reset: true },
            className: "placeOrderNav",
        },
        {
            title: EnumRouteTitles.HOME,
            value: EnumRouteTitles.HOME,
            route: "/dashboard",
            icon: React.createElement("i", { className: "edel-icon-home-4" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.LEAD_DASHBOARD,
            value: EnumRouteTitles.LEAD_DASHBOARD,
            route: "/dashboard/lead-dashboard",
            icon: React.createElement("i", { className: "edel-icon-lead-dashboard-2" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.AOP_LEADS,
            value: EnumRouteTitles.AOP_LEADS,
            route: "/dashboard/aop-leads",
            icon: React.createElement("i", { className: "edel-icon-person-in-frame" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.PRODUCT_BOUQUET,
            value: EnumRouteTitles.PRODUCT_BOUQUET,
            route: "/dashboard/product-bouquet",
            subName: "watchlist",
            icon: React.createElement("i", { className: "edel-icon-offerings" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.ORDER_BOOK,
            value: EnumRouteTitles.ORDER_BOOK,
            route: "/dashboard/orderbook",
            icon: React.createElement("i", { className: "edel-icon-orderbook-2" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.REPORTS,
            value: EnumRouteTitles.REPORTS,
            route: "#",
            icon: React.createElement("i", { className: "edel-icon-reporting-2" }),
            subList: [
                // {
                //   title: "MTF Reporting",
                //   route: "/dashboard/mtf-report",
                //   // icon: <i className="edel-icon-report"></i>,
                //   routeState: { reset: true },
                // },
                {
                    title: EnumRouteTitles.CLIENT_REPORTS,
                    value: EnumRouteTitles.CLIENT_REPORTS,
                    route: "/dashboard/client-report",
                    routeState: { reset: true },
                },
                {
                    title: EnumRouteTitles.RM_PARTNER_REPORT,
                    value: EnumRouteTitles.RM_PARTNER_REPORT,
                    route: "/dashboard/rm-partners-reports",
                    // icon: <i className="edel-icon-report"></i>,
                },
            ],
        },
        {
            title: EnumRouteTitles.OPEN_ACCOUNT,
            value: EnumRouteTitles.OPEN_ACCOUNT,
            route: "#",
            icon: React.createElement("i", { className: "edel-icon-person-in-frame" }),
            routeState: { reset: true },
            onClick: openAccountModal,
        },
        {
            title: EnumRouteTitles.SERVICE_REQUEST,
            value: EnumRouteTitles.SERVICE_REQUEST,
            route: "/dashboard/service-request",
            icon: React.createElement("i", { className: "edel-icon-service-request-3" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.ADVISORY,
            value: EnumRouteTitles.ADVISORY,
            route: "/dashboard/advisory-dashboard",
            icon: React.createElement("i", { className: "edel-icon-new-advisory" }),
            routeState: { reset: true },
        },
        {
            title: (React.createElement("div", { className: "d-flex flex-column" },
                EnumRouteTitles.TRANSFER_IN,
                React.createElement("span", { className: "DMsanR_08_400 opacity-50" }, "Download ARN Transfer Forms"))),
            value: EnumRouteTitles.TRANSFER_IN,
            route: "#",
            icon: React.createElement("i", { className: "edel-icon-reporting-2" }),
            subList: [
                {
                    title: EnumRouteTitles.MUTUAL_FUNDS,
                    value: EnumRouteTitles.MUTUAL_FUNDS,
                    route: "/dashboard/mf-transfer",
                    routeState: { reset: true },
                },
            ],
        },
        {
            title: EnumRouteTitles.BULLPEN,
            value: EnumRouteTitles.BULLPEN,
            icon: React.createElement("i", { className: "edel-icon-other-info" }),
            routeState: { reset: true },
            onClick: getOtherAppRedirectingURL,
        },
        {
            title: EnumRouteTitles.CIP,
            value: EnumRouteTitles.CIP,
            icon: React.createElement("i", { className: "edel-icon-other-info" }),
            onClick: getOtherAppRedirectingURL,
        },
        {
            title: EnumRouteTitles.OLD_PARTNER_PORTAL,
            onClick: redirectToFPDPortal,
            value: EnumRouteTitles.OLD_PARTNER_PORTAL,
            icon: React.createElement("i", { className: "edel-icon-other-info" }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.NUWAI,
            onClick: getNuwaiRedirectURL,
            value: EnumRouteTitles.NUWAI,
            icon: React.createElement(Edelicon, { className: "edel-icon-nuwai", paths: 76 }),
            routeState: { reset: true },
        },
        {
            title: EnumRouteTitles.WATCH_LIST,
            route: "/dashboard/watch-list-dashboard",
            subName: "watchlist",
            value: EnumRouteTitles.WATCH_LIST,
            icon: React.createElement("i", { className: "edel-icon-watchlist-2" }),
            routeState: { reset: true },
            isShowComingSoon: true,
        },
        {
            title: EnumRouteTitles.TRANSACTIONS,
            value: EnumRouteTitles.TRANSACTIONS,
            route: "/dashboard/transaction-dashboard",
            icon: React.createElement("i", { className: "edel-icon-transactions-2" }),
            routeState: { reset: true },
            isShowComingSoon: true,
        },
        {
            title: EnumRouteTitles.NLA,
            value: EnumRouteTitles.NLA,
            route: "https://learningacademy.nuvamawealth.com/#!",
            icon: (React.createElement("img", { src: learnicon, alt: "learning", className: "DMSanN_16_400 txt_blue-tint hand_cursor" })),
            routeState: { reset: true },
            target: "_blank",
        },
    ];
    var _c = __read(useState(true), 2), isSidebarCollapsed = _c[0], setIsSidebarCollapsed = _c[1];
    var openedSidebarRef = React.useRef(null);
    var _d = loginDI.login.getIsRMPartnerFRM(), isRM = _d.isRM, isPartner = _d.isPartner, isFRM = _d.isFRM;
    var myRouteList = useSelector(function (state) { return state.Profile.RouteDetails.reducersData; }).routeList;
    var navigate = useNavigate();
    var _e = __read(useState([]), 2), navigationSidebarMenu = _e[0], setNavigationSidebarMenu = _e[1];
    var expiringLeads = useSelector(function (state) { return state.SalesHome.expiringLeads.reducersData; });
    var loginData = useSelector(function (state) { return state.Login.LoginReducer.reducersData.loginData; });
    var getMenuList = function (strPartnerCategory, sidebarList) {
        profileDi.profile.getUserMenu({ strPartnerCategory: strPartnerCategory }).then(function (resp) {
            var routeList = sidebarList;
            if (isPartner) {
                routeList = [];
                sidebarList.map(function (localRoute) {
                    var _a, _b, _c, _d;
                    if (((_a = resp === null || resp === void 0 ? void 0 : resp.titles) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        ((_b = resp === null || resp === void 0 ? void 0 : resp.titles) === null || _b === void 0 ? void 0 : _b.includes(localRoute === null || localRoute === void 0 ? void 0 : localRoute.title))) {
                        routeList.push(localRoute);
                    }
                    if (((_c = resp === null || resp === void 0 ? void 0 : resp.titles) === null || _c === void 0 ? void 0 : _c.length) > 0 && ((_d = localRoute === null || localRoute === void 0 ? void 0 : localRoute.subList) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                        var filteredSubList = localRoute.subList.filter(function (subTab) {
                            var _a;
                            return (_a = resp === null || resp === void 0 ? void 0 : resp.titles) === null || _a === void 0 ? void 0 : _a.includes(subTab === null || subTab === void 0 ? void 0 : subTab.title);
                        });
                        if (filteredSubList.length > 0) {
                            var updatedLocalRoute = __assign(__assign({}, localRoute), { subList: filteredSubList });
                            routeList.push(updatedLocalRoute);
                        }
                    }
                });
            }
            setNavigationSidebarMenu(routeList);
        });
    };
    var getSupersetMenuList = function (filterSidebarConstantsForMF) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedNav, resp, reportingSection, dynamicSupersetLinks, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updatedNav = cloneDeep(filterSidebarConstantsForMF);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, profileDi.profile.getSupersetMenuList({
                            username: "",
                        })];
                case 2:
                    resp = _b.sent();
                    reportingSection = updatedNav.find(function (item) { return item.title === EnumRouteTitles.REPORTS; });
                    if (reportingSection && reportingSection.subList && Array.isArray(resp)) {
                        dynamicSupersetLinks = resp.map(function (dashboard) { return ({
                            title: dashboard.name,
                            route: "/dashboard/superset-reports/".concat(dashboard.id, "/").concat(encodeURIComponent(EnumRouteTitles.SUPERSET_REPORT)),
                            routeState: { reset: true },
                        }); });
                        (_a = reportingSection.subList).push.apply(_a, __spreadArray([], __read(dynamicSupersetLinks), false));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    setNavigationSidebarMenu(updatedNav);
                    return [2 /*return*/];
            }
        });
    }); };
    var getAccessibleSidebarConstants = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mfSpecificSideBarConstants, arnSpecificSideBarConstants, _a, isMFAccessible, isARNAccessible;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mfSpecificSideBarConstants = new Set([
                        EnumRouteTitles.PLACE_ORDER,
                        EnumRouteTitles.PRODUCT_BOUQUET,
                    ]);
                    arnSpecificSideBarConstants = new Set([EnumRouteTitles.TRANSFER_IN]);
                    return [4 /*yield*/, Promise.all([
                            checkIfMFIsAccessible(),
                            checkIfARNIsAccessible(),
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), isMFAccessible = _a[0], isARNAccessible = _a[1];
                    return [2 /*return*/, sidebarNavConstants.filter(function (item) {
                            var value = item.value;
                            if (!isMFAccessible && mfSpecificSideBarConstants.has(value)) {
                                return false;
                            }
                            if (!isARNAccessible && arnSpecificSideBarConstants.has(value)) {
                                return false;
                            }
                            return true;
                        })];
            }
        });
    }); };
    var handleUpdateSidebarMenu = function () { return __awaiter(void 0, void 0, void 0, function () {
        var partnerCategory, filterSidebarConstantsForMF;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    partnerCategory = localStorage.getItem(ELocalStorageKeys.PartnerCategory);
                    return [4 /*yield*/, getAccessibleSidebarConstants()];
                case 1:
                    filterSidebarConstantsForMF = _a.sent();
                    if (partnerCategory) {
                        getMenuList(partnerCategory, sidebarNavConstants); // check for partner
                    }
                    else {
                        getSupersetMenuList(filterSidebarConstantsForMF);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAccountOpeningUrlsFn = function () {
        profileDi.profile
            .getAccountOpeningUrls()
            .then(function (resp) {
            setAccountOpeningUrls(resp);
        })
            .catch(function (e) {
            setAccountOpeningUrls([]);
        });
    };
    useEffect(function () {
        handleUpdateSidebarMenu();
        getAccountOpeningUrlsFn();
    }, [loginData]);
    var routeLeadDashboard = function () {
        var _a, _b;
        if (expiringLeads &&
            expiringLeads.expiringLeads &&
            !!((_a = expiringLeads.expiringLeads) === null || _a === void 0 ? void 0 : _a.totalitems) &&
            Number((_b = expiringLeads.expiringLeads) === null || _b === void 0 ? void 0 : _b.totalitems) > 0) {
            return (config.applicationFolder +
                "dashboard/lead-dashboard?isExpiry=" +
                true +
                "&tabFlag=" +
                0);
        }
    };
    var generateSupportTooltip = function (isCollapsedSidebar) {
        return (React.createElement(GenericPopup, { isHeadline: true, parentClass: "sidebar-tooltip support-sidebar-tooltip", placement: "right-end", children: React.createElement(React.Fragment, null, "Client Support 18001023335"), button: React.createElement("div", { className: "footer-links" },
                React.createElement("i", { className: "edel-icon-support-2 hand_cursor" }),
                !isCollapsedSidebar && (React.createElement("span", { className: "txt_white DMSanN_14_400" }, "Help & Support"))) }));
    };
    var generateNotificationTooltip = function (isCollapsedSidebar) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return (React.createElement(GenericTooltip, { button: React.createElement("div", { className: "footer-links d-flex hand_cursor" },
                React.createElement("i", { className: "edel-icon-round-bell" }),
                expiringLeads &&
                    expiringLeads.expiringLeads &&
                    !!((_a = expiringLeads.expiringLeads) === null || _a === void 0 ? void 0 : _a.totalitems) &&
                    Number((_b = expiringLeads.expiringLeads) === null || _b === void 0 ? void 0 : _b.totalitems) > 0 && (React.createElement("span", { className: "txt_white notification-info-wrapper" }, Number((_c = expiringLeads.expiringLeads) === null || _c === void 0 ? void 0 : _c.totalitems))),
                !isCollapsedSidebar && (React.createElement("span", { className: "txt_blackOne1" }, "Notification"))), noButton: true, toolTipText: React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("div", { className: "info-container DMSanN_14_400" },
                        "You Have ",
                        "",
                        expiringLeads &&
                            expiringLeads.expiringLeads &&
                            !!((_d = expiringLeads.expiringLeads) === null || _d === void 0 ? void 0 : _d.totalitems) &&
                            Number((_e = expiringLeads.expiringLeads) === null || _e === void 0 ? void 0 : _e.totalitems) > 0 ? (React.createElement("a", { href: routeLeadDashboard(), className: "txt_white" },
                            React.createElement("span", { className: "common-link-child ".concat(expiringLeads &&
                                    expiringLeads.expiringLeads &&
                                    !!((_f = expiringLeads.expiringLeads) === null || _f === void 0 ? void 0 : _f.totalitems) &&
                                    Number((_g = expiringLeads.expiringLeads) === null || _g === void 0 ? void 0 : _g.totalitems) > 0
                                    ? "DMSanN_14_400 hand_cursor"
                                    : "DMSanN_14_400") }, (expiringLeads &&
                                expiringLeads.expiringLeads &&
                                !!((_h = expiringLeads.expiringLeads) === null || _h === void 0 ? void 0 : _h.totalitems) &&
                                Number((_j = expiringLeads.expiringLeads) === null || _j === void 0 ? void 0 : _j.totalitems)).toString()))) : (0),
                        "",
                        " Expiring Leads"))), placement: "right", tooltipRef: openedSidebarRef }));
    };
    var generateSidebarFooter = function () {
        return (React.createElement("div", { className: "d-flex flex-column DMSanM_14_500 footer-links-container " },
            !loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("div", { className: "hand_cursor d-flex align-items-center footer-links", onClick: function () {
                    window.open("https://learningacademy.nuvamawealth.com/#!", "_blank");
                } },
                React.createElement("i", { className: "edel-icon-nuvama-learning" }),
                React.createElement("span", { className: "txt_white DMSanN_14_400" }, "Nuvama Learning Academy"))),
            React.createElement("div", { className: "hand_cursor d-flex align-items-center" }, generateNotificationTooltip()),
            React.createElement("div", { className: "hand_cursor d-flex align-items-center footer-links" }, generateSupportTooltip()),
            React.createElement("div", { className: "hand_cursor d-flex align-items-center footer-links logout-button-wrapper", onClick: function () { return props === null || props === void 0 ? void 0 : props.logoutUser(); } },
                React.createElement("i", { className: "edel-icon-export hand_cursor" }),
                React.createElement("span", { className: "txt_redWarm DMSanN_14_400" }, "Logout"))));
    };
    var generateCollapsedFooter = function () {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center collapsed-footer-link-container" }, !loginDI.login.getIsRMPartnerFRM().isPartner && (React.createElement("i", { className: "edel-icon-nuvama-learning" }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericCollapsibleNavigation, { isCollapsed: isSidebarCollapsed, setIsCollapsed: setIsSidebarCollapsed, navigationMenu: navigationSidebarMenu, collapsedHeader: React.createElement("img", { src: logoIcon, alt: "nuvama", width: 30, className: "collapsed-sidebar-header hand_cursor", onClick: function () { return navigate("/"); } }), header: React.createElement("img", { src: nameLogo, alt: "nuvama", width: 96, onClick: function () { return navigate("/"); }, 
                // onClick={() => navigate("/")}
                className: "hand_cursor" }), parentClass: "primary-navigation-sidebar", trigger: ESidebarTrigger.HOVER, sideBarRef: openedSidebarRef }),
        isShowOpenAccountModal && (React.createElement("div", { className: "account-opening-wrapper" },
            React.createElement(AccountOpening, { accountOpeningUrls: accountOpeningUrls, setIsShowOpenAccountModal: setIsShowOpenAccountModal, isShowOpenAccountModal: isShowOpenAccountModal })))));
};
export default NavigationSidebar;
